import '../styles/styles.scss';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { appWithTranslation } from 'next-i18next';
import { sendOpenPage, sendPageview } from '../utils/analytics';
const MyApp = ({ Component, pageProps, router }) => {
  useEffect(() => {
    const handleRouteChange = (url) => {
      sendPageview(url);
      sendOpenPage(url);
    };
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return (
    <Component {...pageProps} />
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default appWithTranslation(MyApp);
